import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const OurCraft = () => {
  const b = useBilingual();

  const craftItems = [
    {
      label: b("Joinery", "木作接合"),
      caption: b(
        "Precision wood joinery and structural assembly",
        "精準的木作接合與結構組裝",
      ),
      image:
        asset("/editorial/craft-joinery.jpg"),
    },
    {
      label: b("Upholstery", "軟包工藝"),
      caption: b(
        "Hand-selected fabrics and expert upholstery work",
        "嚴選布料與專業軟包工藝",
      ),
      image:
        asset("/editorial/craft-upholstery.jpg"),
    },
    {
      label: b("Finishing", "表面處理"),
      caption: b(
        "Multi-stage lacquer, stain, and surface treatment",
        "多道塗裝、染色與表面處理工序",
      ),
      image:
        asset("/editorial/craft-finishing.jpg"),
    },
    {
      label: b("Quality Control", "品質控管"),
      caption: b(
        "Rigorous inspection at every production stage",
        "每道工序均有嚴格品管檢查",
      ),
      image:
        asset("/editorial/craft-qc.jpg"),
    },
  ];

  return (
    <section className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="mb-14">
          <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">
            {b("Our Craft", "我們的工藝")}
          </p>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {b("Made with Intention,", "用心製作，")}
            <br />
            {b("Built to Last", "經久耐用")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {craftItems.map((item) => (
            <div key={item.label} className="group relative overflow-hidden rounded-xl bg-stone-900">
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.label}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p
                  className="text-white text-xl font-bold mb-1"
                  style={{ fontFamily: "var(--font-display)" }}
                >
                  {item.label}
                </p>
                <p className="text-white/60 text-xs leading-relaxed">{item.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurCraft;
